var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.888,
    height: 47.593,
    viewBox: "0 0 56.888 47.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.004 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.04 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-68.478,82.016c-1.768,0-3.719-.1-5.641-.277a58.394,58.394,0,0,1-6.552-.98,37.8,37.8,0,0,1-6.4-1.9,23.051,23.051,0,0,1-2.811-1.36,15.541,15.541,0,0,1-2.374-1.662,11.759,11.759,0,0,1-1.75-1.858,9.686,9.686,0,0,1-1.107-1.886,9.252,9.252,0,0,1-.778-3.593A10.815,10.815,0,0,1-95,64.071a79.306,79.306,0,0,1,7.5-7.013,37.73,37.73,0,0,1,3.249-2.346A26.378,26.378,0,0,1-81.2,53.018a22.072,22.072,0,0,1,2.981-1.145,23.349,23.349,0,0,1,3.032-.7,40.968,40.968,0,0,1,6.707-.443,26.372,26.372,0,0,1,5.066.52A34.039,34.039,0,0,1-59.126,52.4a31.236,31.236,0,0,1,4.053,1.663c.128.073,2.649,1.505,5.4,3.262,1.647,1.052,3.052,2.012,4.176,2.854a15.683,15.683,0,0,1,2.823,2.52,17.922,17.922,0,0,1,1.241,2.81,10.52,10.52,0,0,1,.39,1.581,8.208,8.208,0,0,1,.1,1.657,7.287,7.287,0,0,1-.279,1.714,7.787,7.787,0,0,1-.762,1.76,10.1,10.1,0,0,1-1.356,1.794A15.023,15.023,0,0,1-45.4,75.821a22.944,22.944,0,0,1-2.613,1.651,28.968,28.968,0,0,1-2.865,1.353,39.322,39.322,0,0,1-6.139,1.906,51.791,51.791,0,0,1-6.1,1c-.938.1-1.886.172-2.816.22C-66.8,81.993-67.657,82.016-68.478,82.016Z",
    transform: "translate(96.216 -50.407)",
    fill: "#b32626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.654,47.879c-9.218,0-14.824,1.3-26.253,13.2A9.508,9.508,0,0,0-95.22,72.415c5.23,4.5,15.964,6.1,23.566,6.1,7.029,0,16.732-1.611,22.884-6.132,5.94-4.366,4.683-8.859,2.646-12.684-2.2-2.81-12.188-8.477-12.271-8.525a32.617,32.617,0,0,0-13.258-3.3m0-.648A33.016,33.016,0,0,1-58.095,50.6s10.272,5.812,12.516,8.745c1.845,3.45,3.851,8.665-2.808,13.559s-16.883,6.258-23.267,6.258c-6.483,0-18.213-1.284-23.989-6.258a10.206,10.206,0,0,1-2.808-12.2C-87.139,48.916-81.522,47.231-71.654,47.231Z",
    transform: "translate(99.392 -47.231)",
    fill: "#cd0303"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.004 5.062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.946 24.289) rotate(-143.989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.413,18.295,0,17.557c.426-1.208,1.747-4.944,3.087-8.7.952-2.669,1.728-4.827,2.306-6.413.343-.941.619-1.688.82-2.22L6.3,0l.067.227c.163.552.386,1.329.664,2.309.469,1.651,1.1,3.9,1.874,6.688C9.989,13.129,11.06,17.015,11.413,18.295Z",
    transform: "translate(0.448 0.932)",
    fill: "#981919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.707,1.953C5.5,5.205,2.866,12.611.9,18.192l10.532.681C9.822,13.04,7.681,5.328,6.707,1.953M6.784,0h0c.141.059,5.51,19.579,5.51,19.579L0,18.784S6.623,0,6.784,0Z",
    transform: "translate(0 0)",
    fill: "#d52020"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6859.354,3613.25l8.451-17.613-16.626-.5Z",
    transform: "translate(-6830.748 -3586.38)",
    fill: "#981919",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7041.4,3550.285c.137-.126-3.566-18.995-3.566-18.995l-9.115,6.314S7041.268,3550.411,7041.4,3550.285Z",
    transform: "translate(-6991.856 -3528.441)",
    fill: "#c22521",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7125.369,3508.174l-9.976-7.655,1.028,4.107Z",
    transform: "translate(-7070.503 -3500.519)",
    fill: "none",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6653.85,3512.559l9.78-8.451-7.5,19.8",
    transform: "translate(-6651.687 -3503.776)",
    fill: "none",
    stroke: "#d52020",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6680.115,3716.8c.153.086,24.725,21.934,24.725,21.934l-13.319-16.448S6679.963,3716.714,6680.115,3716.8Z",
    transform: "translate(-6675.515 -3691.715)",
    fill: "#981919",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6813.516,3792.6c-.8.16-13.64-16.528-13.64-16.528s11.232,1.685,12.677,1.524C6812.714,3777.52,6814.318,3792.444,6813.516,3792.6Z",
    transform: "translate(-6784.19 -3745.504)",
    fill: "#d52020",
    stroke: "#cd0303",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6938.479,3778.727c-.047-.025.65,15.083.833,15.064s10.461-16.293,10.461-16.293S6941.348,3779.029,6938.479,3778.727Z",
    transform: "translate(-6909.959 -3746.794)",
    fill: "#981919",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6968.5,3739.74s-19.458,19.795-19.5,19.882,10.275-16.386,10.275-16.386S6966.278,3740.99,6968.5,3739.74Z",
    transform: "translate(-6919.508 -3712.531)",
    fill: "#ab3636",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6810.155,3876.65l-8.263,17.59s16.463-.626,20.783-4.82C6822.55,3889.295,6810.155,3876.65,6810.155,3876.65Z",
    transform: "translate(-6773.244 -3862.503)",
    fill: "#a11919",
    stroke: "#d52020",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.513 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.882,95.619c-.851,0-1.656-.015-2.435-.03-.664-.012-1.292-.024-1.857-.024-.812,0-1.635-.033-2.447-.1-.859-.069-1.7-.175-2.514-.314a19.762,19.762,0,0,1-4.725-1.374,9.4,9.4,0,0,1-3.486-2.506,5.926,5.926,0,0,1-.991-1.721,6.063,6.063,0,0,1-.356-2.086,1.712,1.712,0,0,1,.189-.783,2.693,2.693,0,0,1,.519-.691,9.843,9.843,0,0,1,1.629-1.208c.355-.228.691-.444.986-.67a9.221,9.221,0,0,1,1.258-.8,11.788,11.788,0,0,1,1.417-.634,15.53,15.53,0,0,1,1.549-.483c.517-.133,1.072-.251,1.65-.35a31.349,31.349,0,0,1,3.483-.381c1.047-.061,2.167-.09,3.524-.09.824,0,1.7.031,2.6.092.973.066,1.952.166,2.912.3,1.044.143,2.059.322,3.016.533a28.348,28.348,0,0,1,2.913.8,13.6,13.6,0,0,1,4.679,2.477,5.842,5.842,0,0,1,1.362,1.7,4.475,4.475,0,0,1,.362.973,4.527,4.527,0,0,1,.126,1.069c0,1.52-.859,2.742-2.625,3.737A14.883,14.883,0,0,1-7,94.23c-.962.3-2.076.583-3.4.86a24.137,24.137,0,0,1-3.225.427C-14.595,95.586-15.657,95.619-16.882,95.619Z",
    transform: "translate(36.018 -81.046)",
    fill: "#981919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.666,78.518c-4.542,0-9.6.318-12.684,2.675-.3.228-.647.453-1.008.685-1.076.691-2.188,1.406-2.188,2.41,0,5.74,7.647,7.776,14.195,7.776.566,0,1.193.012,1.863.024.762.014,1.58.03,2.429.03a32.694,32.694,0,0,0,6.406-.522c5.969-1.245,8.631-2.93,8.631-5.463,0-5.548-10.823-7.616-17.645-7.616m0-.648c6.391,0,18.293,1.873,18.293,8.264,0,3.579-4.39,5.106-9.146,6.1-3.706.773-8.019.481-10.831.481-6.391,0-14.843-2.033-14.843-8.424,0-1.757,2.2-2.652,3.45-3.61C-32.5,78.2-27.3,77.87-22.666,77.87Z",
    transform: "translate(39.194 -77.87)",
    fill: "#cd0303"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6992.94,3824.07l3.29,17.518s10.492-5.1,5.293-14.149C7001.62,3827.343,6992.94,3824.07,6992.94,3824.07Z",
    transform: "translate(-6946.606 -3814.791)",
    fill: "#981919",
    stroke: "#d52020",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.f3fab430107582245c67c7fa522f4961.svg";
export { ForwardRef as ReactComponent };